/* eslint-disable @typescript-eslint/default-param-last */
import { IInterviewType } from "@/types/interview.types";
import {
  GET_INTERVIEW_DETAILS,
  GET_INTERVIEW_META,
  SET_STARTED_TIME,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const interviewReducer = (
  state = initialState.interview,
  action: IInterviewType,
) => {
  switch (action.type) {
    case `${GET_INTERVIEW_DETAILS}_SUCCESS`:
      return {
        ...state,
        ...action.payload,
      };
    case `${GET_INTERVIEW_META}_SUCCESS`:
      return {
        ...state,
        ...action.payload,
      };
    case SET_STARTED_TIME:
      if (state?.access_code ?? state?.accessCode) {
        return {
          ...state,
          started_at: action.payload.started_at,
        };
      }
      return state;
    default:
      return state;
  }
};

export default interviewReducer;
